<template>
  <div class="login-container">
    <div class="login-form">
      <img src="@/assets/images/logo.png" class="logo" />
      <div class="title-container">
        <div class="title">欢迎登录</div>
        <p class="p">基于场景的特情处置系统（{{ this.clientName }}）</p>
      </div>
      <div class="input-box">
        <img src="@/assets/images/us1.png" />
        <el-input placeholder="请输入账号" v-model="name" />
      </div>
      <div class="input-box">
        <img src="@/assets/images/us2.png" />
        <el-input placeholder="请输入登录密码" type="password" v-model="password" @keyup.enter.native="login" />
      </div>
      <div class="input-box">
        <i class="el-icon-picture-outline" style="color: white" />
        <el-input
          v-model="imageCodeValue"
          type="number"
          placeholder="请输入图形验证码"
          @keyup.enter.native="btnSendMailCode"
        />
        <img :src="base64Image" @click="pullImageCode" />
      </div>
      <div class="input-box">
        <i class="el-icon-message" style="color: white" />
        <el-input
          v-model="mailCodeValue"
          type="number"
          placeholder="请输入邮件验证码"
          @keyup.enter.native="login"
        />
        <el-link style="color: white" :disabled="btnSendDisabled" @click="btnSendMailCode">{{ btnSendMailCodeTxt }}</el-link>
      </div>
      <el-button @click="login" :disabled="btnLoginDisabled">登录</el-button>
      <el-link style="color: white;margin-top: 20px;" @click="resetPassword">忘记密码</el-link>
    </div>
  </div>
</template>

<script>
import { encrypt } from "@/util/rsa";
import { imageCode, sendMailCode, userCurrent, userLogin } from "@/api/api";

const defaultImageCode = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAeCAIAAAA0IQ7mAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQElEQVRYhe3PAQ0AIRDAsOf9ez5cQDJaBduame8l/+2A0wzXGa4zXGe4znCd4TrDdYbrDNcZrjNcZ7jOcJ3hug3P5wM5Ssm5sAAAAABJRU5ErkJggg==";
const NAME_MAPPING = {
  ROLE_SOC: "SOC端",
  ROLE_MECH: "机务端",
  ROLE_SCDR: "空警值班端",
  ROLE_SIM: "模拟机端"
};
export default {
  name: "Login",
  data() {
    // console.log(['process.env', process.env])
    return {
      // name: '18700001019',
      // password: '111111',
      // client: 'ROLE_SOC'
      name: "",
      password: "",
      imageCodeValue: "",
      mailCodeValue: "",
      btnSendInterval: 0,
      uuid: "",
      base64Image: defaultImageCode,
      client: process.env.VUE_APP_TOKEN_CLIENT,
      clientName: NAME_MAPPING[process.env.VUE_APP_TOKEN_CLIENT] || "-"
    };
  },
  // watch: {
  //   client: {
  //     handler(val, oldVal) {
  //       if ('development' === process.env.NODE_ENV) {
  //         if ('localhost:9527' === location.host) {
  //           switch (val) {
  //             case 'ROLE_SOC':
  //               this.name = '18700009006'
  //               break
  //             case 'ROLE_MECH':
  //               this.name = '18700009007'
  //               break
  //             case 'ROLE_SCDR':
  //               this.name = '18700009011'
  //               break
  //             case 'ROLE_SIM':
  //               this.name = '18700009012'
  //               break
  //           }
  //         }
  //       }
  //     }
  //   }
  // },
  created() {
    if ("development" === process.env.NODE_ENV) {
      if ("localhost" === location.hostname) {
        this.password = "111111";
        switch (this.client) {
          case "ROLE_SOC":
            this.name = "18700009006";
            break;
          case "ROLE_MECH":
            this.name = "18700009007";
            break;
          case "ROLE_SCDR":
            this.name = "18700009011";
            break;
          case "ROLE_SIM":
            this.name = "18700009012";
            break;
        }
      }
    }
    this.pullImageCode();
  },
  computed: {
    btnLoginDisabled() {
      return !(this.mailCodeValue && this.name && this.password);
    },
    btnSendDisabled() {
      return !(this.imageCodeValue && this.name && this.btnSendInterval === 0);
    },
    btnSendMailCodeTxt() {
      return this.btnSendInterval > 0 ? `${this.btnSendInterval}s` : "发送";
    }
  },
  methods: {
    async login() {
      if (this.btnLoginDisabled) {
        if (!this.name) {
          this.$message.warning("请输入登录名");
        } else if (!this.password) {
          this.$message.warning("请输入密码");
        } else if (!this.imageCodeValue) {
          this.$message.warning("请输入图片验证码");
        } else if (!this.mailCodeValue) {
          this.$message.warning("请输入邮箱验证码");
        }
        return;
      }
      // PILOT：18700001004
      // SOC：18700001005
      // MECH：18700001007
      const pwd = encrypt(this.password);
      //  console.log(this.password)
      const res = await userLogin(this.client, {
        username: this.name,
        password: pwd,
        mailCode: this.mailCodeValue
      });
      if (res.code === "A00000") {
        localStorage.setItem("x-token", res.data[0]);
        const user = await userCurrent();
        if (user.code === "A00000") {
          localStorage.setItem("currentUser", JSON.stringify(user.data[0]));
          this.$store.commit("setCurrentUser", user.data[0]);
        }
        this.$message({
          type: "success",
          message: res.message
        });
        if ("ROLE_SOC" === this.client) {
          this.$router.push("/largescreen");
        } else {
          this.$router.push("/index");
        }
      } else {
        this.$message({
          type: "warning",
          message: res.message
        });
      }
    },
    async pullImageCode() {
      this.base64Image = defaultImageCode;
      this.uuid = "";
      const result = await imageCode();
      if (result.code === "A00000") {
        this.uuid = result.data[0].uuid;
        this.base64Image = result.data[0].base64Image;
      }
    },
    async btnSendMailCode() {
      if (this.btnSendDisabled) {
        if (!this.name) {
          this.$message.warning("请输入登录名");
        } else if (!this.imageCodeValue) {
          this.$message.warning("请输入图片验证码");
        }
        return;
      }
      try {
        this.btnSendInterval = 60;
        const result = await sendMailCode(this.uuid, this.imageCodeValue, this.name);
        if (result.code === "A00000") {
          this.$message.success("邮件发送成功");
          const countInterval = setInterval(() => {
            this.btnSendInterval--;
            if (this.btnSendInterval <= 0) {
              window.clearInterval(countInterval);
              this.btnSendInterval = 0;
            }
          }, 1000);
        } else {
          this.btnSendInterval = 0;
          this.$message.warning(`邮件发送失败：${result.message}`);
          this.pullImageCode();
        }
      } catch (e) {
        this.$message.warning("邮件发送失败");
        this.btnSendInterval = 0;
      }
    },
    resetPassword() {
      this.$router.push('/reset-passwd');
    }
  }
};
</script>

<style lang="less">
.login-container {
  background: url("~@/assets/images/1.png") no-repeat #141b2d;
  background-size: 100%;
  width: 100%;
  height: 100vh;
  min-height: 800px;
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0;
      -webkit-appearance: none;
      border-radius: 0;
      padding: 12px 5px 12px 15px;
      height: 47px;
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="less" scoped>
.logo {
  position: absolute;
  width: 76px;
  opacity: 1;
  top: -38px;
  left: calc(50% - 38px);
}

.el-button {
  background: #2769ec;
  border-radius: 28px;
  height: 56px;
  width: 100%;
  border: none;
  color: #fff;
  margin-top: 28px;
  font-size: 16px;
}

.input-box {
  background: #262d40;
  border: 1px solid #525f89;
  border-radius: 8px;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 26px;
  margin-bottom: 24px;
}

.login-container {
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-form {
    position: relative;
    width: 600px;
    max-width: 100%;
    padding: 76px;
    background: url("~@/assets/images/loginbg.png") no-repeat;
    background-size: 100% 100%;
    height: 534px;
    box-sizing: border-box;
    margin-top: 100px;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    margin-bottom: 25px;

    .title {
      font-size: 26px;
      margin: 0 auto 40px auto;
      text-align: center;
      font-weight: bold;
      color: #fff;
    }

    .p {
      opacity: 0.87;
      font-size: 16px;
      color: #fff;
      margin: 0;
      margin-top: 10px;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue